import { useEffect, useState } from "react";
import Api from "../openapi";
import { AdminAreaResponse } from "../openapi/client";

export default function useAreas() {
  const [areaList, setAreaList] = useState<AdminAreaResponse[]>([]);

  const getAreas = async () => {
    try {
      const res = await Api.Area.listAreas();
      setAreaList(res.data);
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    getAreas();
  }, []);

  const updateArea = async (areas: AdminAreaResponse[]) => {
    try {
      const res = await Api.Area.upsertAreas(areas);

      const targetAreasRefactor = res.data.map((i) => {
        return {
          id: i.id,
          name: i.name,
          geometry: i.geometry,
        };
      });

      setAreaList((state) => {
        const temp = [...state];
        targetAreasRefactor.forEach((i) => {
          const targetArea = temp.find((a) => a.id === i.id);
          if (targetArea) {
            targetArea.name = i.name;
            targetArea.geometry = { ...i.geometry };
          } else {
            temp.push({
              id: i.id,
              name: i.name,
              geometry: { ...i.geometry },
            });
          }
        });
        return temp;
      });
    } catch (error) {
      throw error;
    }
  };

  const deleteArea = async (area: AdminAreaResponse) => {
    try {
      await Api.Area.deleteAreaById(area.id!);
      setAreaList(areaList.filter((i) => i.id !== area.id));
    } catch (error) {
      throw error;
    }
  };

  return { areaList, updateArea, deleteArea };
}
